import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {HasLicenseModuleDirective} from './directives/has-license-module.directive';


@NgModule({
  declarations: [
    HasLicenseModuleDirective,
  ],
  exports: [
    HasLicenseModuleDirective,
  ],
  imports: [
    CommonModule,
  ]
})
export class LicenseModule { }
